(() => {
  const nav = document.getElementById('hs-floating-nav');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('details[open]') || !details.closest('details-modal.header__search')) return;
    requestAnimationFrame(() => {
      if (details.open) details.querySelector('input[type="search"]')?.focus({preventScroll:true});
    });
  }, true);
  const desktopCart = document.getElementById('hs-desktop-cart');
  let feedbackTimer, lastConfirmationSource = '', lastConfirmationAt = 0, lastKnownItemCount = null;
  function celebrateAddition() {
    if (nav.dataset.hsCartFeedback !== 'false') {
      const targets = Array.from(document.querySelectorAll('[data-hs-cart],[data-hs-desktop-open],.header__icon--cart'));
      clearTimeout(feedbackTimer);
      targets.forEach(el => el.classList.remove('hs-cart-added'));
      // Force a style recalculation after removal so the same CSS animation
      // starts from frame zero on every confirmed add, including rapid repeats.
      if (targets.length) void targets[0].offsetWidth;
      targets.forEach(el => el.classList.add('hs-cart-added'));
      feedbackTimer = setTimeout(() => targets.forEach(el => el.classList.remove('hs-cart-added')), 750);
    }
    if (nav.dataset.hsCartHaptic !== 'false' && window.matchMedia('(pointer: coarse)').matches && typeof navigator.vibrate === 'function') {
      try { navigator.vibrate(12); } catch (_) { /* Optional device feedback must never affect the cart. */ }
    }
  }
  function readRenderedCartCount() {
    const values = Array.from(document.querySelectorAll('[data-hs-count],[data-cart-count]'))
      .map(el => Number.parseInt(el.textContent, 10))
      .filter(Number.isFinite);
    return values.length ? Math.max(...values) : null;
  }
  lastKnownItemCount = readRenderedCartCount();
  const cartCountObserver = new MutationObserver(() => {
    const nextCount = readRenderedCartCount();
    if (!Number.isFinite(nextCount)) return;
    const previousCount = lastKnownItemCount;
    lastKnownItemCount = nextCount;
    if (previousCount !== null && nextCount > previousCount) celebrateAddition();
  });
  document.querySelectorAll('[data-hs-count],[data-cart-count]').forEach(el => {
    cartCountObserver.observe(el, { childList: true, subtree: true, characterData: true });
  });
  desktopCart?.querySelector('[data-hs-desktop-open]')?.addEventListener('click', event => {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('show-cart', { detail: true }));
  });
  desktopCart?.querySelector('[data-hs-desktop-gift]')?.addEventListener('click', () => nav.querySelector('[data-hs-present]')?.click());
  const menu = document.getElementById('hs-objective-menu');
  const objective = nav.querySelector('[data-hs-objectives]');
  const notice = document.querySelector('.hs-nav-feedback');
  let noticeTimer, refreshTimer, pending = false, repeat = false;
  function message(text, keepVisible = false) {
    clearTimeout(noticeTimer);
    notice.textContent = text;
    notice.hidden = false;
    if (!keepVisible) noticeTimer = setTimeout(() => { notice.hidden = true; }, 5500);
  }
    const dockViewport = window.matchMedia('(max-width: 767px)');
  let previousDockScrollY = Math.max(0, window.scrollY);
  let dockDownTravel = 0, dockUpTravel = 0, dockIdleTimer;
  function expandDock() {
    clearTimeout(dockIdleTimer);
    nav.classList.remove('is-compact');
    dockDownTravel = 0;
    dockUpTravel = 0;
  }
  function updateDockOnScroll() {
    const y = Math.max(0, window.scrollY);
    const delta = y - previousDockScrollY;
    previousDockScrollY = y;
    if (!dockViewport.matches || y < 100 || !menu.hidden || nav.querySelector(':focus-visible')) {
      expandDock();
      return;
    }
    if (delta > 0) {
      dockDownTravel += delta;
      dockUpTravel = 0;
      if (dockDownTravel > 24) nav.classList.add('is-compact');
    } else if (delta < 0) {
      dockUpTravel -= delta;
      dockDownTravel = 0;
      if (dockUpTravel > 8) expandDock();
    }
    clearTimeout(dockIdleTimer);
    dockIdleTimer = setTimeout(expandDock, 700);
  }
  window.addEventListener('scroll', updateDockOnScroll, { passive: true });
  window.addEventListener('resize', () => { previousDockScrollY = Math.max(0, window.scrollY); if (!dockViewport.matches) expandDock(); }, { passive: true });
  nav.addEventListener('focusin', expandDock);
  objective.addEventListener('click', expandDock);
function closeMenu() { menu.hidden = true; objective.setAttribute('aria-expanded', 'false'); }
  objective.addEventListener('click', () => { menu.hidden = !menu.hidden; objective.setAttribute('aria-expanded', String(!menu.hidden)); });
  menu.querySelector('[data-hs-close]').addEventListener('click', () => { closeMenu(); objective.focus(); });
  document.addEventListener('click', event => { if (!menu.contains(event.target) && !objective.contains(event.target)) closeMenu(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
  if (location.pathname === '/') nav.querySelector('[data-hs-home]').setAttribute('aria-current', 'page');
  nav.querySelector('[data-hs-cart]').addEventListener('click', () => { closeMenu(); window.dispatchEvent(new CustomEvent('show-cart', { detail: true })); });
  let giftScriptPromise, giftPending = false;
  function loadGiftForm() {
    if (window.HolyGiftForm) return Promise.resolve();
    if (giftScriptPromise) return giftScriptPromise;
    giftScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => { script.remove(); giftScriptPromise = null; reject(new Error('O carregamento demorou mais que o esperado. Toque em Presente para tentar novamente.')); }, 15000);
      script.src = nav.dataset.hsGiftScript;
      script.onload = () => { clearTimeout(timeout); if (window.HolyGiftForm) resolve(); else { giftScriptPromise = null; reject(new Error('Não foi possível carregar. Tente novamente.')); } };
      script.onerror = () => { clearTimeout(timeout); script.remove(); giftScriptPromise = null; reject(new Error('Confira sua conexão e toque em Presente novamente.')); };
      document.head.appendChild(script);
    });
    return giftScriptPromise;
  }
  nav.querySelector('[data-hs-present]')?.addEventListener('click', async () => {
    closeMenu();
    const existing = document.getElementById('holylead-primeira-compra');
    if (existing) { existing.querySelector('input')?.focus(); return; }
    if (giftPending) return;
    giftPending = true;
    const button = nav.querySelector('[data-hs-present]');
    button.setAttribute('aria-busy', 'true');
    notice.hidden = true;
    try {
      await loadGiftForm();
      await window.HolyGiftForm.open();
      notice.hidden = true;
    } catch (error) {
      message(error.inactive ? 'O brinde está indisponível neste momento.' : 'Não conseguimos abrir seu presente agora. Toque em Presente para tentar novamente.');
    } finally {
      giftPending = false;
      document.querySelectorAll('[data-hs-present],[data-hs-desktop-gift]').forEach(el => el.removeAttribute('aria-busy'));
    }
  });
  nav.dataset.giftReady = 'true';
  if (window.HolyGiftBoot) {
    clearTimeout(window.HolyGiftBoot.timer);
    if (window.HolyGiftBoot.pending) {
      window.HolyGiftBoot.pending = false;
      nav.querySelector('[data-hs-present]')?.click();
    }
  }
  const giftNudge = document.querySelector('[data-hs-gift-nudge]');
  if (giftNudge) {
    let dismissed = false, hideNudgeTimer;
    const hideGiftNudge = () => {
      dismissed = true;
      giftNudge.hidden = true;
      clearTimeout(hideNudgeTimer);
      try { sessionStorage.setItem('hs_gift_nudge_seen', '1'); } catch (_) {}
    };
    const positionGiftNudge = () => {
      if (giftNudge.hidden) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const giftButton = isMobile ? nav.querySelector('[data-hs-present]') : document.querySelector('[data-hs-desktop-gift]');
      const buttonRect = giftButton?.getBoundingClientRect();
      if (!buttonRect?.width) {
        giftNudge.style.removeProperty('left');
        giftNudge.style.removeProperty('right');
        giftNudge.style.removeProperty('transform');
        return;
      }
      const nudgeWidth = giftNudge.getBoundingClientRect().width;
      if (!nudgeWidth) return;
      const center = Math.max(nudgeWidth / 2 + 16, Math.min(window.innerWidth - nudgeWidth / 2 - 16, buttonRect.left + buttonRect.width / 2));
      giftNudge.style.left = center + 'px';
      if (isMobile) {
        giftNudge.style.removeProperty('right');
        giftNudge.style.removeProperty('transform');
      } else {
        giftNudge.style.right = 'auto';
        giftNudge.style.transform = 'translateX(-50%)';
      }
    };
    giftNudge.addEventListener('click', event => {
      if (event.target.closest('[data-hs-gift-nudge-close]')) return;
      hideGiftNudge();
      nav.querySelector('[data-hs-present]')?.click();
    });
    giftNudge.querySelector('[data-hs-gift-nudge-close]').addEventListener('click', event => {
      event.stopPropagation();
      hideGiftNudge();
    });
    window.addEventListener('resize', positionGiftNudge);
    window.addEventListener('scroll', positionGiftNudge, { passive: true });
    document.querySelectorAll('[data-hs-present],[data-hs-desktop-gift]').forEach(button => button.addEventListener('click', hideGiftNudge));
    let seen = false;
    try { seen = sessionStorage.getItem('hs_gift_nudge_seen') === '1'; } catch (_) {}
    if (!seen) setTimeout(() => {
      if (dismissed || document.getElementById('holylead-primeira-compra') ||
          document.body.classList.contains('hs-gaveta-aberta') || document.body.classList.contains('opened-kit') ||
          Array.from(document.querySelectorAll('[role="dialog"]:not([hidden])')).some(dialog => {
            const style = getComputedStyle(dialog);
            return dialog.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
          })) return;
      giftNudge.hidden = false;
      positionGiftNudge();
      try { sessionStorage.setItem('hs_gift_nudge_seen', '1'); } catch (_) {}
      hideNudgeTimer = setTimeout(() => { giftNudge.hidden = true; }, 30000);
    }, 7000);
  }
  async function refreshCounts() {
    if (pending) { repeat = true; return; }
    pending = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (!Number.isFinite(cart.item_count)) return;
      const previousItemCount = lastKnownItemCount;
      lastKnownItemCount = cart.item_count;
      // Some product cards only announce a generic cart change. Detect the
      // confirmed quantity increase so the feedback still runs on every add.
      if (previousItemCount !== null && cart.item_count > previousItemCount) celebrateAddition();
      if (desktopCart) {
        desktopCart.hidden = cart.item_count <= 0;
        const quantity = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`;
        desktopCart.querySelector('[data-hs-desktop-count]').textContent = String(cart.item_count);
        desktopCart.querySelector('[data-hs-desktop-open]').setAttribute('aria-label', `Abrir carrinho: ${quantity}`);
        desktopCart.setAttribute('aria-label', `Ver carrinho: ${quantity}`);
      }
      const store = window.Alpine?.store('cart');
      if (store) { store.itemsCount = cart.item_count; store.items = cart.items; }
      document.querySelectorAll('[data-hs-count],[data-cart-count]').forEach(el => {
        const next = String(cart.item_count);
        if (el.textContent !== next) { el.textContent = next; el.classList.remove('is-updated'); requestAnimationFrame(() => el.classList.add('is-updated')); }
      });
      document.querySelectorAll('.header__icon--cart,[data-cart-sidebar]').forEach(link => {
        link.setAttribute('aria-label', 'Carrinho: ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' itens'));
      });
      document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(el => {
        el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' itens');
      });
      nav.querySelector('[data-hs-cart]').setAttribute('aria-label', `Carrinho: ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`);
    } catch (error) { /* A later cart event retries without interrupting shopping. */ }
    finally { pending = false; if (repeat) { repeat = false; refreshCounts(); } }
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCounts, 100); }
  function confirmedAddition() { scheduleRefresh(); }
  window.addEventListener('cart-change', scheduleRefresh);
  window.addEventListener('hs:cart-added', confirmedAddition);
  document.addEventListener('atc-core:added', confirmedAddition);
  window.addEventListener('pageshow', scheduleRefresh);
  scheduleRefresh();
})();
